import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from './redux';
import { LeagueList } from './component';


export default connect(mapStateToProps, mapDispatchToProps)(LeagueList);
